import { render, staticRenderFns } from "./AIAssistantChatWindow.vue?vue&type=template&id=85f5c3fa&scoped=true&"
import script from "./AIAssistantChatWindow.vue?vue&type=script&lang=js&"
export * from "./AIAssistantChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistantChatWindow.vue?vue&type=style&index=0&id=85f5c3fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f5c3fa",
  null
  
)

export default component.exports